import { CloudWatchRecord } from './types';
import { PropertyFilterProperty } from '@amzn/awsui-collection-hooks/dist/cjs/interfaces';
import { SelectProps } from "@amzn/awsui-components-react";

  export const removeMetricsNesting = (data: any[]): CloudWatchRecord[] => {
    return data.map(item => {
      const { __typename, ...rest } = item.metrics; 
      return {
        timestamp: item["timestamp"],
        ...rest
      };
    }) as CloudWatchRecord[];
  };
  
  export const transformMetricsData = (data: any[]): CloudWatchRecord[] => {
    return data.map(item => {
      const { unique_azs, __typename, ...otherMetrics } = item.metrics; 
      return {
        timestamp: item["timestamp"],
        ...otherMetrics
      };
    }) as CloudWatchRecord[];
  };

export const PAGE_SIZE_OPTIONS = [
  { value: 10, label: '10 Records' },
  { value: 30, label: '30 Records' },
  { value: 50, label: '50 Records' },
];

export const getFilterCounterText = (count) =>
  `${count} ${count === 1 ? 'match' : 'matches'}`;

export const generateColumns = (data: CloudWatchRecord[]) => {
  const fields = new Set<string>();
  data.forEach(record => {
    Object.keys(record).forEach(key => fields.add(key));
  });

  return Array.from(fields).map(field => ({
    id: field,
    header: field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, ' $1'),
    cell: (item: CloudWatchRecord) => item[field]?.toString() || '-',
    sortingField: field,
    width: field === 'timestamp' ? 200 : 150
  }));
};

export const generateFilteringProperties = (data: CloudWatchRecord[]): PropertyFilterProperty[] => {
  const fields = new Set<string>();
  data.forEach(record => {
    Object.keys(record).forEach(key => fields.add(key));
  });

  return Array.from(fields).map(field => ({
    propertyLabel: field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, ' $1'),
    key: field,
    groupValuesLabel: `${field} values`,
    operators: typeof data[0][field] === 'number'
      ? [':', '!:', '=', '!=', '>', '<', '>=', '<=']
      : [':', '!:', '=', '!=', 'contains', 'does not contain']
  }));
};

export const COLOR_PALETTE = [
  '#1f97ff', '#ff9900', '#00a1c9', '#df3312', '#7aa116',
  '#9b63d0', '#eb6f6f', '#00b7b7', '#666666', '#f2ca4b',
];

export const AGGREGATION_TIME_OPTIONS: SelectProps.Options = [
  { label: 'No aggregation', value: '0' },
  { label: '1 hour', value: '3600' },
  { label: '2 hours', value: '7200' },
  { label: '4 hours', value: '14400' },
  { label: '12 hours', value: '43200' },
  { label: '1 day', value: '86400' },
];

export const AGGREGATION_TYPE_OPTIONS: SelectProps.Options = [
  { label: 'Sum', value: 'sum' },
  { label: 'Average', value: 'avg' },
  { label: 'Maximum', value: 'max' },
  { label: 'Minimum', value: 'min' },
  { label: 'Count', value: 'count' },
];